import React, { useState } from 'react';

const SearchFilter = ({ data, onFilter, type, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCriteria, setFilterCriteria] = useState('all');

  const handleSearch = (term) => {
    setSearchTerm(term);
    filterData(term, filterCriteria);
  };

  const handleFilterChange = (criteria) => {
    setFilterCriteria(criteria);
    filterData(searchTerm, criteria);
  };

  const filterData = (term, criteria) => {
    let filtered = [...data];

    // Apply search term filter
    if (term.trim()) {
      filtered = filtered.filter(item => {
        switch (type) {
          case 'class':
            return item.class_name?.toLowerCase().includes(term.toLowerCase()) ||
                   item.class_id?.toLowerCase().includes(term.toLowerCase());
          case 'teacher':
            return item.teacher_name?.toLowerCase().includes(term.toLowerCase()) ||
                   item.teacher_id?.toLowerCase().includes(term.toLowerCase());
          case 'student':
            return item.student_name?.toLowerCase().includes(term.toLowerCase()) ||
                   item.student_id?.toLowerCase().includes(term.toLowerCase());
          default:
            return true;
        }
      });
    }

    // Apply criteria filter
    if (criteria !== 'all') {
      switch (type) {
        case 'class':
          filtered = filtered.filter(item => {
            if (criteria === 'elective') {
              return item.class_level >= 6;
            } else if (criteria === 'general') {
              return item.class_level < 6;
            } else {
              return item.class_level === parseInt(criteria);
            }
          });
          break;
        case 'teacher':
          filtered = filtered.filter(item => {
            const subjects = Array.isArray(item.subjects) ? item.subjects : [item.subjects];
            return subjects.some(subject => subject === criteria);
          });
          break;
        case 'student':
          filtered = filtered.filter(item => {
            if (criteria === 'elective') {
              return item.elective_subjects && item.elective_subjects.length > 0;
            } else if (criteria === 'core') {
              return !item.elective_subjects || item.elective_subjects.length === 0;
            } else {
              return item.class_id === criteria;
            }
          });
          break;
        default:
          // No additional filtering for unknown types
          break;
      }
    }

    onFilter(filtered);
  };

  const getFilterOptions = () => {
    switch (type) {
      case 'class':
        return [
          { value: 'all', label: '全部班級' },
          { value: 'general', label: '一般班級' },
          { value: 'elective', label: '選修班級' },
          { value: '1', label: '中一' },
          { value: '2', label: '中二' },
          { value: '3', label: '中三' },
          { value: '4', label: '中四' },
          { value: '5', label: '中五' },
          { value: '6', label: '中六' }
        ];
      case 'teacher':
        const subjects = [...new Set(data.flatMap(item => item.subjects || []))];
        return [
          { value: 'all', label: '全部科目' },
          ...subjects.map(subject => ({ value: subject, label: subject }))
        ];
      case 'student':
        const classes = [...new Set(data.map(item => item.class_id))];
        return [
          { value: 'all', label: '全部學生' },
          { value: 'core', label: '核心科目學生' },
          { value: 'elective', label: '選修科目學生' },
          ...classes.map(classId => ({ value: classId, label: classId }))
        ];
      default:
        return [{ value: 'all', label: '全部' }];
    }
  };

  return (
    <div className="search-filter">
      <div className="search-section">
        <div className="search-input-group">
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            className="search-input"
          />
          <div className="search-icon">🔍</div>
        </div>
      </div>

      <div className="filter-section">
        <div className="filter-group">
          <label className="filter-label">篩選條件:</label>
          <select
            value={filterCriteria}
            onChange={(e) => handleFilterChange(e.target.value)}
            className="filter-select"
          >
            {getFilterOptions().map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="results-info">
        <span className="results-count">
          顯示 {data.length} 項結果
        </span>
        {(searchTerm || filterCriteria !== 'all') && (
          <button
            onClick={() => {
              setSearchTerm('');
              setFilterCriteria('all');
              onFilter([...data]);
            }}
            className="clear-filters-btn"
          >
            清除篩選
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchFilter;
